export default __webpack_public_path__ + "static/media/0x689f8e5913c158ffb5ac5aeb83b3c875f5d20309.e2b3a0e1.webp";